module.exports = __webpack_public_path__ + "static/media/userinvitation.9f6caeec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/userinvitation.png
// module id = 1855
// module chunks = 193